module.exports = __webpack_public_path__ + "img/product-preview-37.dc14d10.png";